export default __webpack_public_path__ + "static/media/liter.a5551b90.jpg";